import { create } from "zustand";
import { fetchPlanetResources } from "@api/planetApi";

// Store global para manejar el estado de recursos
const usePlanetStore = create((set) => ({
  resources: null,
  loading: false,
  error: null,

  // Carga los recursos desde el backend
  loadResources: async (playerId) => {
    set({ loading: true, error: null });
    try {
      const data = await fetchPlanetResources(playerId);
      set({ resources: data, loading: false });
    } catch (err) {
      console.error("Error al cargar recursos:", err);
      set({ error: err.message, loading: false });
    }
  },
}));

export default usePlanetStore;